import { CheckCircle2Icon } from "lucide-react";

import type { ProjectLeadTaskDraftController } from "./useProjectLeadTaskDraft";

export function ProjectLeadWorkbenchStatus(props: {
  readonly controller: ProjectLeadTaskDraftController;
}) {
  if (props.controller.error !== null) {
    return (
      <p
        role="alert"
        className="border-t border-destructive-border bg-destructive-surface px-4 py-2 text-sm text-destructive md:px-6"
      >
        {props.controller.error}
      </p>
    );
  }
  if (props.controller.preview !== null) {
    return (
      <p className="flex items-center gap-2 border-t border-success-border bg-success-surface px-4 py-2 text-sm text-success md:px-6">
        <CheckCircle2Icon className="size-4" aria-hidden />
        Validated {props.controller.preview.tasks.length} tasks. Review once more, then create
        atomically.
      </p>
    );
  }
  return null;
}
